
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 513 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0052B4","d":"M0 0h513v342H0z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M513 210.9H202.2V342h-79.8V210.9H0V131.1h122.4V0h79.8v131.1H513v61.2z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"}})])
          )
        }
      }
    